<div class="ratings-container inline-block" [class.compact-layout]="useCompactLayout">
  <span class="single-info-short" *ngIf="imdbRating">
    <span *ngIf="!imdbId"><img alt="IMDb" title="IMDb" class="rating-icon" src="./assets/images/imdb_star.png">{{formatImDBRating(imdbRating)}}</span>
    <a *ngIf="imdbId" title="IMDb" [href]="getImdbLink()" target="_blank"><img alt="IMDb" title="IMDb" class="rating-icon" src="./assets/images/imdb_star.png">{{formatImDBRating(imdbRating)}}</a>
  </span>

  <span class="single-info-short" *ngIf="tomatoesRating">
    <span *ngIf="!tomatoesUrl"><img alt="Rotten Tomatoes" title="Rotten Tomatoes" class="rating-icon" [src]="getTomatoesIcon()">{{tomatoesRating}}%</span>
    <a *ngIf="tomatoesUrl" title="Rotten Tomatoes" [href]="tomatoesUrl" target="_blank"><img alt="Rotten Tomatoes" title="Rotten Tomatoes" class="rating-icon" [src]="getTomatoesIcon()">{{tomatoesRating}}%</a>
  </span>

  <span class="single-info-short" *ngIf="letterboxdRating">
    <span *ngIf="!letterboxdUrl"><img alt="Letterboxd" title="Letterboxd" class="rating-icon" src="./assets/images/letterboxd.png">{{formatLetterboxdRating(letterboxdRating)}}</span>
    <a *ngIf="letterboxdUrl" title="Letterboxd" [href]="letterboxdUrl" target="_blank"><img alt="Letterboxd" title="Letterboxd" class="rating-icon letterboxd-icon" src="./assets/images/letterboxd.png">{{formatLetterboxdRating(letterboxdRating)}}</a>
  </span>

  <span class="single-info-short" *ngIf="metacriticRating">
    <span *ngIf="!metacriticUrl">
      <img alt="Metacritic" title="Metacritic" class="rating-icon metacritic-icon" src="./assets/images/metacritic.png">
      <span [class]="getMetacriticColor() + ' metacritic-rating'">
        {{metacriticRating}}
      </span>
    </span>
    <a *ngIf="metacriticUrl" title="Metacritic" [href]="metacriticUrl" target="_blank">
      <img alt="Metacritic" title="Metacritic" class="rating-icon metacritic-icon" src="./assets/images/metacritic.png">
      <span [class]="getMetacriticColor() + ' metacritic-rating'">
        {{metacriticRating}}
      </span>
    </a>
  </span>
</div>
